/*
import {
  ht,
  hf,
  useGblz,
  l,
  f
} from 'lib';
*/

import * as ihd from './ihd';
import * as f from "./_cmFTH"; // 廃止予定
import * as ht from './_ht';
import * as hf from './_hf';

export const ilz_20z = () => ({
  _20rz: {},
  i19rz: {},
  _31rs: [],
  _801z: {},
  _802z: {},
}) as ht.dz;

export const crt_20z = async () => {
  const __20z = ilz_20z();
  hf.udtDz(__20z._20rz, {
    ... ihd.i('_20r'),
  });
  hf.udtDz(__20z.i19rz, {
    ... ihd.i('i19r'),
  });
  __20z._31rs = [];
  __20z._801s = {};
  hf.udtDz(__20z._801s, {
    ... ihd.i('_801'),
    _801t1100s: 'i19r',
  });
  __20z._802s = {};
  hf.udtDz(__20z._802s, {
    ... ihd.i('_802'),
    _802t1100s: 'i19r',
  });
  return __20z;
};

export const load_20rLsAsync = async (
) => {
  const _cdn = f.vdd(false, false);
  const _ls = await f.loadLsAsync({
    tgt: '_20rs',
    cdn: _cdn,
  });
  return _ls;
};

export const load_20rDzAsync = async ( pz: { // クライアント詳細画面
  _20r_key: ht.n
} ) => {
  const _cdn1 = `_key = ${pz._20r_key}`;
  const _dz1 = await f.loadDzAsync({
    tgt: '_20rs',
    cdn: _cdn1,
  });
  const _cdn2 = f.vdd(true, false) + ` AND _dmn = ${pz._20r_key}`;
  const _dz2 = await f.loadDzAsync({
    tgt: 'i19rs',
    cdn: _cdn2,
    lwrz: {
      '_801s': {
        tgt: '_801s',
        cdn: f.vdd(false, false) + ` AND _dmn = ${pz._20r_key} AND _801t1100s = 'i19r' AND _801a1100k = {i19r_key}`,
        rlcz: {
          i19r_key: 'i19rs._key',
        }
      },
      '_802s': {
        tgt: '_802s',
        cdn: f.vdd(false, false) + ` AND _dmn = ${pz._20r_key} AND _802t1100s = 'i19r' AND _802a1100k = {i19r_key}`,
        rlcz: {
          i19r_key: 'i19rs._key',
        }
      },
    }
  });
  const _cdn3 = f.vdd(true, false) + ` AND _dmn = ${pz._20r_key}`;
  const _ls3 = await f.loadLsAsync({
    tgt: '_31rs',
    cdn: _cdn3,
    fld: '*', // save 時の key, pfx エラーを回避するために必要
    lwrz: {
      'i191s': {
        tgt: 'i191s',
        cdn: f.vdd(false, false) + ` AND _dmn = ${pz._20r_key} AND i191_31r1k = {_31rs_key}`,
        rlcz: {
          _31rs_key: '_31rs._key',
        },
      },
    }
  });
  return {
    _20rz: _dz1,
    i19rz: { ... _dz2, cldz: undefined },
    _31rs: _ls3,
    _801z: hf.get1(_dz2.cldz._801s, {}),
    _802z: hf.get1(_dz2.cldz._802s, {}),
  };
};

export const loadI19rDzAsync = async ( pz: { // ログイン共通画面
  i19r_dmn?: ht.n,
  i19ra1110s?: ht.s
  dmnName?: ht.s,
  cdn?: ht.s,
  _31r_fst?: ht.n,
} ) => {
  let _cdn = f.vdd(true, false);
  if (pz.i19r_dmn) _cdn += ` AND _dmn=${pz.i19r_dmn}`;
  if (pz.i19ra1110s) _cdn += ` AND i19ra1110s='${pz.i19ra1110s}'`;
  if (pz.dmnName) _cdn += ` AND (i19ra1110s='${pz.dmnName}' OR i19ra1210s='${pz.dmnName}')`;
  if (pz._31r_fst) _cdn += ` AND _dmn = (SELECT _dmn FROM _31rs WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND _fst = ${pz._31r_fst})`;
  if (pz.cdn) _cdn += ` AND (${pz.cdn})`;
  //hf.l(`IcvI19 79: ${_cdn}`);
  const _dz = await f.loadDzAsync({
    tgt: 'i19rs',
    cdn: _cdn,
    lwrz: {
      _20rs: {
        tgt: '_20rs',
        cdn: f.vdd(false, false) + ` AND _key={i19r_dmn}`,
        rlcz: {
          i19r_dmn: 'i19rs._dmn',
        }
      },
      '_801s': {
        tgt: '_801s',
        cdn: f.vdd(false, false) + ` AND _801t1100s = 'i19r' AND _801a1100k = {i19r_key}`,
        rlcz: {
          i19r_key: 'i19rs._key',
        }
      },
    },
  });
  //hf.l(`IcvI19 90: ${hf.s(_dz)}`);
  return {
    i19rz: { ... _dz, cldz: undefined },
    _20rz: hf.get1(_dz?.cldz?._20rs, {}),
    _801z: hf.get1(_dz?.cldz?._801s, {}),
  };
};

export const loadI191DzAsync = async ( pz: {
  _31r_fst: ht.n,
} ) => {
  let _cdn = f.vdd(false);
  _cdn += ` AND i191_31r1k = (
    SELECT 
      _key 
    FROM 
      _31rs 
    WHERE 
      ${f.vdd()} 
      AND _fst = ${pz._31r_fst}
  )`;
  const _dz = await f.loadDzAsync({
    tgt: 'i191s',
    cdn: _cdn,
  });
  return {
    i191z: { ... _dz, cldz: undefined },
  };
};

export const save_20rDzAsync = async (pz: {
  _20z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _cdn1 = 
    pz._20z._20rz._key > 0 ? 
      `_key = ${pz._20z._20rz._key}` 
    : `_icn = '${pz._20z._20rz._icn}' AND _pfx = '${pz._20z._20rz._pfx}'`; 
  const _ls1 = await f.upsDzAsync({ // ドメインの追加
    tgt: '_20rs',
    dmn: 0,
    cdn: _cdn1,
    dz: {
      ... pz._20z._20rz,
    },
  });
  const _dz1 = _ls1[0];
//hf.l(`icvI19___Mz 183: ${hf.s(pz._20z._31rs)}`)
  hf.udtDz(pz._20z._801z, {
    _801t1100s: 'i19r',
  });
  hf.udtDz(pz._20z._802z, {
    _802t1100s: 'i19r',
  });
  const _dz2 = await f.ugdDzAsync({
    tgt: 'i19rs',
    dmn: _dz1._key,
    dz: {
      ... pz._20z.i19rz,
    },
    lwrz: {
      _31rs: {
        tgt: '_31rs',
        dmn: _dz1._key,
        ls: pz._20z._31rs,
        lwrz: {
          i191s: {
            tgt: 'i191s',
            dmn: _dz1._key,
            bSetLsFromUpr: true,
            udtz: {
              i191_31r1k: '_31rs._key',
            }
          }
        }
      },
      _801s: {
        tgt: '_801s',
        dmn: _dz1._key,
        ls: [pz._20z._801z],
        udtz: {
          _801a1100k: 'i19rs._key',
        }
      },
      _802s: {
        tgt: '_802s',
        dmn: _dz1._key,
        ls: [pz._20z._802z],
        udtz: {
          _802a1100k: 'i19rs._key',
        }
      },
    },
    atrs: 
      pz._20z.i19rz._dlt != 1 ? 
      [].concat(
        ihd.f('i19ra1120s').atrs, // 管理者用ログインID
        ihd.f('i19ra1130s').atrs, // 管理者用ログインID
      )
      : undefined,

  });
  return {
    _20rz: { ... _dz1, cldz: undefined },
  };
};
